import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../constants'

export const TableHeader = ({ profitData }) => {
  // const percentTable = useSelector(ppsSelector.percentTable)
  // const isDelta = percentTable.is_delta
  const current = profitData.$price_cost_current_price

  return (
    <Root>
      <LeftWrapper>
        <ProjectCol>
          <StickyText>Project Revenue</StickyText>
          <StickyNumber>{`฿ ${current}`}</StickyNumber>
        </ProjectCol>
      </LeftWrapper>
      <Wrapper>
        <EmptyRow />
        <MonthRow>
          <Col>
            <HeaderText>Activity Based</HeaderText>
            <HeaderNumber>Last Month</HeaderNumber>
          </Col>
        </MonthRow>
        <MonthRow>
          <Col>
            <HeaderText>Activity Based</HeaderText>
            <HeaderNumber>Current Month</HeaderNumber>
          </Col>
        </MonthRow>
        <MonthRow>
          <Col>
            <HeaderText>Cost Based</HeaderText>
            <HeaderNumber>Actual</HeaderNumber>
          </Col>
        </MonthRow>
        <MonthRow>
          <Col>
            <HeaderText>GAP</HeaderText>
            <HeaderNumber>(Activity - Cost)</HeaderNumber>
          </Col>
        </MonthRow>
      </Wrapper>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
`

const LeftWrapper = styled.div`
  display: flex;
  flex-basis: 40%;
  padding: 0 18px;
  background: rgba(0, 0, 0, 0.8);
`

const Wrapper = styled(LeftWrapper)`
  flex-basis: 60%;
  background: rgba(0, 0, 0, 0.6);
`

const ProjectCol = styled.div`
  height: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`

const StickyText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #FFFFFF;
`

const StickyNumber = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #FFFFFF;
`

const EmptyRow = styled.div`
  width: 80px;
`

const MonthRow = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 16px;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #FFFFFF;
`

const HeaderNumber = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #FFFFFF;
`

// const ToggleWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   padding-right: 16px;
// `

// const Toggle = styled.div`
//   width: 90px;
//   height: 26px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background: ${p => (p.active ? '#D44B49' : '#686868')};
//   border-radius: 4px;
//   color: #FFFFFF;
//   font-family: ${FONTS.GOTHAM};
//   font-size: ${FONTS.SMALL_SIZE};
//   cursor: pointer;

//   :nth-child(1) {
//     border-radius: 4px 0 0 4px;
//   }

//   :nth-last-child(1) {
//     border-radius: 0 4px 4px 0;
//   }
// `



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/PercentTable/TableHeader.js